import { Image as IImage } from '@/services/Api/generated'
import cn from 'classnames'
import Image from 'next/image'
import { FunctionComponent } from 'react'
import styles from './AdvantageCard.module.scss'
import { Icon, IconName, isIconName } from '@/icons'

type AdvantageCardProps = {
  className?: string
  icon: IImage | IconName
  title: string
  description: string
}
export const AdvantageCard: FunctionComponent<AdvantageCardProps> = ({
  className,
  icon,
  title,
  description,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.icon}>
        {isIconName(icon) ? (
          <Icon name={icon} />
        ) : (
          <Image src={icon.url} alt="" width={56} height={56} unoptimized />
        )}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  )
}
